import * as React from 'react';

import FavoriteIcon from '@mui/icons-material/Favorite';

import type { Disclosure, ResultsForecastDisclosure, SummaryDisclosure } from '../../output/models';

import { color } from '../../utils';

interface Props {
  disclosure: Disclosure | ResultsForecastDisclosure | SummaryDisclosure;
}

export const StockName: React.FC<Props> = ({ disclosure }) => {
  return (
    <>
      {disclosure.fav ? (
        <td className="border border-gray p-1.25 md:px-1.25 md:py-1.5">
          <div className="flex items-center justify-between ">
            <div className="h-[17.14px] overflow-hidden">{disclosure.name}</div>
            <FavoriteIcon htmlColor={color('red', 'pink')} sx={{ width: 10, height: 10 }} />
          </div>
        </td>
      ) : (
        <td className="border border-gray p-1.25 md:px-1.25 md:py-1.5">
          <div className="h-[17.14px] overflow-hidden">{disclosure.name}</div>
        </td>
      )}
    </>
  );
};
